module.exports = __webpack_public_path__ + "media/images/display-a3b9f0eb5c86238432e64dce70be0e54.svg";